import { get } from '.';

import qs from 'qs';

export const getSegments = ({ filters }) => {
  return get(`/segments?${qs.stringify(filters)}`);
};
